export default __webpack_public_path__ + "static/media/bg-image.17c3e5ed.jpg";